export const apiKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweEMxNzM0RTIyQkZiNjEzMDFGQTg0NzE4Q2M2REE4OWZjQTIwNDYyQTEiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTY1ODYzMzcyMTQ5OCwibmFtZSI6ImJvb2stc3dhcCJ9.csiZZPf2PhyJq_5sKVAk_nhoYOMVwZrUXxY8CWmE34w'
